export const fragmentQuizCollaboratorsPagination = /* GraphQL */ `
  fragment fragmentQuizCollaboratorsPagination on QuizCollaboratorPagination {
    total
    per_page
    current_page
    from
    to
    last_page
    has_more_pages
    data {
      id
      quiz_id
      user_email
      user_name
      status
      can_view_crm
      can_manage_quiz
      can_copy
      can_manage_integrations
      can_share
      can_transfer
      can_delete
      can_publish
      expires_at
      created_at
      updated_at
      invited_by
      invited_by_user_email
      is_active
    }
  }
`;

export const fragmentQuizCollaboratorForTeam = /* GraphQL */ `
  fragment fragmentQuizCollaboratorForTeam on QuizCollaborator {
    id
    quiz_id
    user_email
    user_name
    status
    can_manage_quiz
    can_copy
    can_manage_integrations
    can_view_crm
    can_share
    can_transfer
    can_delete
    can_publish
    expires_at
    created_at
    updated_at
    invited_by
    invited_by_user_email
    is_active
  }
`;
